import React from 'react'
import { Typography,Box } from '@mui/material'
import LaundryItem from '../Components/LaundryItem'
export default function Shop() {
    const laundryItems=[
        //{
        // name:"Shirt",
        // icon:"https://i.postimg.cc/G2Kv5Sq8/womans-shirt-78083.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"T-Shirt",
        // icon:"https://i.postimg.cc/LX8WrmCp/shirt.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Pants",
        // icon:"https://i.postimg.cc/tg0dZ6sT/red-pants-icon-icons-com-54600.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Punjabi",
        // icon:"https://i.postimg.cc/W469s85j/kurta.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Payjama",
        // icon:"https://i.postimg.cc/1314DrrL/womans-jeans-78095.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Blazer",
        // icon:"https://i.postimg.cc/sxZDhMQj/mens-blazer-78094.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Kameez",
        // icon:"https://i.postimg.cc/hj1N3gkL/dirndl.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Long Dress",
        // icon:"https://i.postimg.cc/4xp70S3f/tunic-dress-78092.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Cushion Cover",
        // icon:"https://i.postimg.cc/bvJGvNTJ/pillow.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Sofa Cover",
        // icon:"https://i.postimg.cc/hPsP7Rh7/pillow-1.png",
        // price:10,
        // key:1
        // },
        // {
        // name:"Curtains",
        // icon:"https://i.postimg.cc/tT6411VX/curtains.png",
        // price:10,
        // key:1
        // }
        {
            name:"Buttons",
            icon:"https://i.postimg.cc/mkSQbdtP/a.jpg",
            price:0.25,
            key:1
        },
        {
            name:"Collar Stays",
            icon:"https://i.postimg.cc/25qF4FXt/b.jpg",
            price:0.5,
            key:2
        },
        {
            name:"Yarn",
            icon:"https://i.postimg.cc/Hxnwp0bz/c.jpg",
            price:5,
            key:3
        },
        {
            name:"Zippers",
            icon:"https://i.postimg.cc/pTzfSVvY/d.jpg",
            price:2,
            key:4
        },
        {
            name:"Tags",
            icon:"https://i.postimg.cc/6qKrxs5s/e.jpg",
            price:0.2,
            key:5
        },
        {
            name:"Box",
            icon:"https://i.postimg.cc/gcyyq0NG/f.jpg",
            price:10,
            key:6
        }
       
        
    ]
    return (
        <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",width:"100vw", minHeight:"100vh",backgroundColor:"#f4f4f4",marginTop:{md:"7vh"}}}>
            <Typography variant="h3" color="primary" sx={{marginTop:"1rem"}}>Shop Page</Typography>
            <Typography variant="p"  sx={{marginBottom:"1rem"}}>Order your items for shopping</Typography>
            {/**Laundry Items */}
            <Box sx={{marginBottom:{xs:"7vh",md:"0",display:"flex",flexWrap:"wrap",alignItems:"center",justifyContent:"space-around"}}}>
                {laundryItems.map(item=>(<LaundryItem name={item.name} icon={item.icon} price={item.price}/>))}
            </Box>
        </Box>
    )
}
